<form class="geocoder-form" [formGroup]="form">
  <div class="geocoder-form__fields" formArrayName="mapObjects">
    <div *ngFor="let mapObject of mapObjectsControl.controls; let qIndex = index">
      <form-field [controlKey]="qIndex" (deleteField)="deleteByIndex(qIndex)"></form-field>
    </div>
  </div>

  <div tuiGroup class="add-button" [collapsed]="true">
    <button
      tuiButton
      type="button"
      [appearance]="'outline-grayscale'"
      [tuiAppearanceMode]="'checked'"
      [size]="'m'"
      (click)="addMapObject()"
    >
      {{ 'components.geocoder.buttons.createMapObject' | translate }}
    </button>

    <button
      tuiIconButton
      class="tui-group__auto-width-item"
      type="button"
      [appearance]="'outline-grayscale'"
      [tuiAppearanceMode]="'checked'"
      [iconStart]="'@tui.circle-plus'"
      [size]="'m'"
      (click)="addMapObject()"
    ></button>
  </div>
</form>
